import React from "react";
import Marquee from "@/components/Marquee";

export default function Bonus() {
  return (
    <div className="bg-black text-white min-h-screen overflow-hidden">
      {/* 
        SEO 注意事项: 
        1. 页面 Title 应设为: Best Online Casino Bonus Malaysia | U2 Gaming Welcome Rewards
        2. Meta Description: Get the best 200% welcome bonus at U2 Gaming Malaysia. Trusted online casino for slots, live dealer, and fast withdrawals.
      */}

      {/* HERO SECTION */}
      <section className="relative py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          
          {/* LEFT CONTENT */}
          <div>
            {/* 标签加入地域核心词 */}
            <div className="inline-block px-4 py-2 rounded-full border border-orange-500/30 bg-orange-500/10 text-orange-400 text-sm font-bold tracking-widest mb-6">
              #1 TRUSTED ONLINE CASINO MALAYSIA
            </div>

            {/* H1 融入高搜索量关键字 */}
            <h1 className="text-5xl lg:text-7xl font-black leading-tight mb-6">
              U2 ONLINE
              <br />
              <span className="text-orange-500 drop-shadow-[0_0_25px_rgba(249,115,22,0.8)]">
                CASINO BONUS
              </span>
            </h1>

            {/* 文案增加行业深度词汇 */}
            <p className="text-zinc-400 text-lg leading-8 max-w-2xl mb-10">
              Claim your exclusive <strong>Malaysia online casino bonus</strong> at U2 Gaming. 
              From high-RTP <strong>online slots</strong> to immersive <strong>live baccarat</strong>, 
              enjoy seamless mobile gaming with our 200% welcome rewards and fast withdrawal system.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="https://regismyr.wlrdr.xyz/RE/NjljZGRlZWVlNjY0NjRmNjRiN2U0OWQ4"
                target="_blank"
                rel="noreferrer"
                className="px-8 py-4 rounded-full bg-orange-500 hover:bg-orange-400 transition-all duration-300 text-black font-bold shadow-[0_0_30px_rgba(249,115,22,0.5)]"
              >
                Claim My Bonus Now
              </a>

              <a
                href="/contact"
                className="px-8 py-4 rounded-full border border-orange-500 text-orange-400 hover:bg-orange-500 hover:text-black transition-all duration-300 font-semibold"
              >
                VIP Inquiry
              </a>
            </div>
          </div>

          {/* RIGHT SIDE BONUS CARDS - 优化数值与描述 */}
          <div className="grid grid-cols-2 gap-5">
            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 backdrop-blur-sm p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-4">200%</h2>
              <p className="text-xl font-bold mb-2 uppercase">Welcome Pack</p>
              <p className="text-zinc-500 text-sm leading-6">
                Start your gaming journey with a massive boost on your first deposit.[cite: 2]
              </p>
            </div>

            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 backdrop-blur-sm p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-4">DAILY</h2>
              <p className="text-xl font-bold mb-2 uppercase">Cash Rebate</p>
              <p className="text-zinc-500 text-sm leading-6">
                Get unlimited daily rebates on all live casino and slot game turnovers.[cite: 2]
              </p>
            </div>

            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 backdrop-blur-sm p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-4">SECURE</h2>
              <p className="text-xl font-bold mb-2 uppercase">Quick Payout</p>
              <p className="text-zinc-500 text-sm leading-6">
                Experience the fastest <strong>casino withdrawal</strong> in Malaysia.[cite: 2]
              </p>
            </div>

            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 backdrop-blur-sm p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-4">VIP</h2>
              <p className="text-xl font-bold mb-2 uppercase">Loyalty Club</p>
              <p className="text-zinc-500 text-sm leading-6">
                Exclusive rewards and high-limit tables for our loyal Malaysia players.[cite: 2]
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ENHANCED SEO CONTENT SECTION */}
      <section className="py-20 border-t border-orange-500/10 bg-zinc-950">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
          <h2 className="text-4xl lg:text-5xl font-black text-white mb-8 text-center">
            Top <span className="text-orange-500">Malaysia Online Casino</span> Promotions
          </h2>

          <div className="grid md:grid-cols-3 gap-8 text-zinc-400 leading-relaxed">
            <div>
              <h3 className="text-xl font-bold text-orange-300 mb-4 uppercase">Free Credit & Bonuses</h3>
              <p className="text-sm">
                U2 Gaming offers the most competitive <strong>free credit no deposit</strong> 
                events and welcome packages. Our transparency in turnover requirements 
                makes us the preferred <strong>online casino Malaysia</strong> players trust.[cite: 2]
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold text-orange-300 mb-4 uppercase">Diverse Gaming Options</h3>
              <p className="text-sm">
                Whether you prefer <strong>Mega888, 918Kiss</strong>, or international live dealer 
                studios, our bonus covers all major categories to ensure you get the maximum value 
                out of every spin.[cite: 2]
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold text-orange-300 mb-4 uppercase">24/7 Support & Safety</h3>
              <p className="text-zinc-400 text-sm">
                Safety is our priority. U2 Gaming utilizes advanced encryption to protect your 
                data and transactions, providing a secure environment for 
                <strong> online gambling in Malaysia</strong>.[cite: 2]
              </p>
            </div>
          </div>

          {/* 增加一个 FAQ 部分，对长尾流量极度有效 */}
          <div className="mt-20 p-8 rounded-3xl bg-zinc-900/50 border border-orange-500/10">
            <h3 className="text-2xl font-bold text-orange-500 mb-6">Frequently Asked Questions</h3>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <p className="text-white font-semibold mb-2">How do I claim the 200% Welcome Bonus?</p>
                <p className="text-sm text-zinc-500">Register an account and make your first deposit; the bonus will be credited to your wallet automatically.[cite: 2]</p>
              </div>
              <div>
                <p className="text-white font-semibold mb-2">Are there any turnover requirements?</p>
                <p className="text-sm text-zinc-500">Yes, different promotions have specific turnover requirements. Please check our terms and conditions.[cite: 2]</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <Marquee />
    </div>
  );
}
